import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import poServices from '../poServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import moment from 'moment/moment';


function POForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {vendorDD,projectDD, productDD,poTermsList,projectLocationDD,companyDD} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        

        companyId:"",
        vendorId:"",
        projectId:"",
        projectLocationId:"",
        poNo:"",
        orderDate:moment().format(moment.HTML5_FMT.DATE),
        deliveryDate:moment().add(10, 'days').format(moment.HTML5_FMT.DATE),
        productId:"",
        qty:1,
        price:"",
        gstRate:"",
        refDetails:"",
        //totalPrice:"",
        poTerms:"",

    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            companyId:data.companyId,
            vendorId:data.vendorId,
            projectId:data.projectId,
            projectLocationId:data.projectLocationId,
            poNo:data.poNo,
            orderDate:data.orderDate,
            deliveryDate:data.deliveryDate,

            productId:data.productId,
            qty:data.qty,
            price:data.price,
            gstRate:data.gstRate,
            refDetails:data.refDetails,
            poTerms:data.poTerms,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        poNo:Yup.string().required("Required"),
        productId:Yup.string().required("Required"),
        vendorId:Yup.string().required("Required"),
        projectId:Yup.string().required("Required"),
        projectLocationId:Yup.string().required("Required"),
        orderDate:Yup.string().required("Required"),
        deliveryDate:Yup.string().required("Required"),
        qty:Yup.string().required("Required"),
        price:Yup.string().required("Required"),
        gstRate:Yup.string().required("Required"),
        refDetails:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }


    const onSubmit = (values, onSubmitProps) => {   
        
        let payload = {...values};
        payload.grandTotal = (values.qty * values.price) + ((values.price * values.qty* values.gstRate) / 100)
        
        poServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Generate New PO">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Generate New PO</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <button className='btn btn-outline-primary' onClick={updateData}><Edit/> Edit</button>
                    {/*
                    <IconButton  style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                    */}
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Generate PO"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">

                                                <div className="col-md-3 my-2" >
                                                    <h4>Generate PO From</h4>
                                                    {companyDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Select Company / Firm " name="companyId"  
                                                            options={companyDD} multiple={false} 
                                                        />
                                                    }
                                                </div>

                                                <div className='col-md-3 my-2'>
                                                    <h4>To</h4>
                                                    {vendorDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Select Vendor" name="vendorId"  
                                                            options={vendorDD} multiple={false} 
                                                        />
                                                    }
                                                </div>

                                                <div className='col-md-3 my-2'>
                                                    <h4>Ship to</h4>
                                                    {projectLocationDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="SelectProject Location " name="projectLocationId"  
                                                            options={projectLocationDD} multiple={false} 
                                                        />
                                                    }
                                                </div>
                                                

                                                <div className='col-md-3 my-2'>
                                                    <h4>For Project</h4>
                                                    {projectDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Select Project" name="projectId"  
                                                            options={projectDD} multiple={false} 
                                                        />
                                                    }
                                                </div>
                                                
                                            </div>
                                            <div className='row'>
                                                <hr/>
                                                
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Company PO #" name="poNo" 
                                                    />
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Order Date" name="orderDate" 
                                                    />
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Delivery  Date" name="deliveryDate" 
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <hr/>
                                                <div className='col-md-4 my-2'>
                                                    {productDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Product" name="productId"  
                                                            options={productDD} multiple={false} 
                                                        />
                                                    }
                                                </div>

                                                <div className="col-md-2 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number" 
                                                        label="Unit (Quantity)" name="qty" 
                                                    />
                                                </div>

                                                <div className="col-md-3 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number"
                                                        label="Price Per Unit" name="price"   
                                                    />
                                                </div>

                                                <div className='col-md-3 my-2 border rounded p-3'>
                                                    <span className="fw-bold">Total : </span>{formik.values.qty * formik.values.price}
                                                </div>
                                            </div>
                                            <div className='row'>

                                                <div className='col-md-4 my-2'>
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="input" formik={formik} type="number"
                                                        label="GST @ Rate" name="gstRate"   
                                                    />
                                                </div>
                                                
                                                <div className='col-md-4 my-2 border rounded p-3'>
                                                    <span className="fw-bold">GST Amount : </span>{(formik.values.price * formik.values.qty* formik.values.gstRate) / 100}
                                                </div>
                                                
                                                <div className='col-md-8 my-2'>
                                                </div>
                                                <div className='col-md-4 my-2 border rounded p-3'>
                                                    <span className="fw-bold">Grand Total : </span>{formik.values.qty * formik.values.price + ((formik.values.price * formik.values.qty* formik.values.gstRate) / 100)}
                                                </div>

                                                <div className='col-md-12 my-3'>
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Reference Details" name="refDetails"   
                                                    />
                                                </div>
                                                
                                                <div className='col-md-12 my-3'>
                                                    <div>
                                                        <div className="btn-group" role="group">
                                                            <button type='button' className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" >Select Terms </button>

                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    {poTermsList && poTermsList.map(term=>
                                                                        <li key={term.id} >
                                                                            <button 
                                                                                type='button'
                                                                                className='dropdown-item' 
                                                                                onClick={()=>formik.setFieldValue("poTerms", term.details)} 
                                                                            >
                                                                                {term.title}
                                                                            </button>
                                                                        </li>
                                                                    )}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        
                                                    </div>
                                                </div>

                                                <div className='col-md-12 my-3'>
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="PO Terms" name="poTerms"   
                                                    />
                                                </div>
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /*  JSON.stringify(formik)  */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default POForm